/**
 * TaskWorkflows constants
 */

// Template IDs
export const SIMPLE_TEMPLATE_ID = "084e2cc3-c90f-400e-9375-c9fcf09f3ee3";
